import React from "react";

const getUpdateIcon = (color = "#00BB77") => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_12084_10674)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9988 7.12H11.2188L13.9588 4.3C11.2288 1.6 6.80878 1.5 4.07878 4.2C2.76877 5.49195 2.03127 7.25509 2.03127 9.095C2.03127 10.9349 2.76877 12.6981 4.07878 13.99C6.81471 16.6998 11.2229 16.6998 13.9588 13.99C15.3188 12.65 15.9988 11.08 15.9988 9.1H17.9988C17.9988 11.08 17.1188 13.65 15.3588 15.39C11.8488 18.87 6.14878 18.87 2.63878 15.39C-0.861217 11.92 -0.891217 6.28 2.61878 2.81C6.12151 -0.660136 11.7661 -0.660136 15.2688 2.81L17.9988 0V7.12ZM9.49878 5V9.25L12.9988 11.33L12.2788 12.54L7.99878 10V5H9.49878Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_12084_10674">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default getUpdateIcon;
